import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import SearchInput from 'components/wise-components/SearchInput';
import WiseAvatar from 'components/wise-components/WiseAvatar';
import { countryList } from 'data/country2';
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { routePaths } from 'routes/routePaths';

const contactsArray = [
  {
    id: 1,
    name: 'John Smith',
    img: 'https://img.freepik.com/premium-vector/business-man-cartoon-character-smart-clothes-office-style_51635-5680.jpg?w=826',
    country: countryList[1]?.flag
  },
  { id: 2, name: 'Rock Smith', country: countryList[100]?.flag },
  { id: 3, name: 'Pai Smith', country: countryList[9]?.flag },
  { id: 4, name: 'Nye Smith', country: countryList[7]?.flag },
  { id: 5, name: 'Tom Smith', country: countryList[0]?.flag }
];
const recentContactsArray = [
  {
    id: 1,
    name: 'John Smith',

    country: countryList[1]?.flag
  },
  {
    id: 2,
    name: 'Rock Smith',
    country: countryList[100]?.flag,
    img: 'https://img.freepik.com/premium-vector/business-man-cartoon-character-smart-clothes-office-style_51635-5680.jpg?w=826'
  }
];

function ExistingContacts() {
  const navigate = useNavigate();
  const [searchInputValue, setSearchInputValue] = useState('');
  return (
    <div>
      <h3 className="fs-2 fw-semi-bold text-md-center">
        Who are you sending money to?
      </h3>

      <SearchInput
        searchInputValue={searchInputValue}
        setSearchInputValue={setSearchInputValue}
        placeholder="Name, email, phone"
        inputClassName="rounded-5"
        className="mt-4 px-0"
      />

      <div className="mt-4">
        <Button
          onClick={() => navigate(routePaths.CONTACT_TYPES)}
          className="w-100 py-3 bg-transparent text-1000 border-0 shadow-none hover-bg-primary2"
        >
          <Flex justifyContent="between" alignItems="center">
            <Flex alignItems="center">
              <WiseAvatar />
              <p className="mb-0 ms-3 fw-semi-bold">New contact</p>
            </Flex>
            <FontAwesomeIcon icon="angle-right" />
          </Flex>
        </Button>
      </div>

      <div className="mt-4">
        <p className="mb-2">Recent</p>
        <hr />
        <div>
          {recentContactsArray?.map(item => (
            <Button
              key={item.id}
              className="py-3 bg-transparent text-1000 border-0 shadow-none hover-bg-primary2"
            >
              <Flex direction="column" alignItems="center">
                <WiseAvatar
                  userName={item.name}
                  image={item.img}
                  country={item.country}
                />

                <p className="mb-0 mt-2 fs--1 fw-normal">{item.name}</p>
              </Flex>
            </Button>
          ))}
        </div>
      </div>

      <div className="mt-4">
        <p className="mb-2">All</p>
        <hr />
        {contactsArray?.map(item => (
          <Button
            key={item.id}
            className="w-100 py-3 bg-transparent text-1000 border-0 shadow-none hover-bg-primary2"
          >
            <Flex justifyContent="between" alignItems="center">
              <Flex alignItems="center">
                <WiseAvatar
                  userName={item.name}
                  image={item.img}
                  country={item.country}
                />
                <Flex direction="column" alignItems="start" className="ms-3">
                  <p className="mb-0 fw-semi-bold">{item.name}</p>
                  <p className="mb-0 fs--1 fw-normal text-700">
                    EUR account ending in 7890
                  </p>
                </Flex>
              </Flex>
              <FontAwesomeIcon icon="angle-right" />
            </Flex>
          </Button>
        ))}
      </div>
    </div>
  );
}

export default ExistingContacts;
